import logger from './controllers/logger';
import en from './en.json';
// import nl from './nl.json';

const FALLBACK_LOCALE = 'en';
const INTERPOLATION = /\{\{(\w+)\}\}/g;

let locale = 'en';
export let locale_strings = en;
export type LocaleString = keyof typeof locale_strings;

export async function init(_locale = 'en') {
  // Strings used to be fetched from the server per selected language. In the
  // client-only engine there is no localization server, so we keep the bundled
  // en.json that `locale_strings` was initialized with.
  locale = _locale;
}

export function applyDomTranslations(): void {
  document.querySelectorAll<HTMLElement>('[data-i18n-tooltip]').forEach((el) => {
    const key = el.dataset.i18nTooltip;
    if (key) {
      el.dataset.tooltip = t(key);
    }
  });
}

export function t(id: string, variables: Record<string, unknown> = {}): string {
  const messages = locale_strings;

  const lookupId = resolvePluralKey(id, variables, messages);
  let message = messages[lookupId];

  if (!message) message = lookupId;

  const result = replaceVariables(message, variables);

  return result;
}

// helper functions
function pluralSuffix(n: number): 'one' | 'other' {
  return n === 1 ? 'one' : 'other';
}

function resolvePluralKey(
  id: string,
  variables: Record<string, unknown>,
  messages: Record<string, string>,
): string {
  if (!(`${id}_one` in messages && `${id}_other` in messages)) {
    return id;
  }
  const driver = Object.values(variables).find((v) => typeof v === 'number' || Array.isArray(v));
  if (typeof driver === 'number') {
    return `${id}_${pluralSuffix(driver)}`;
  }
  if (Array.isArray(driver)) {
    return `${id}_${pluralSuffix(driver.length)}`;
  }
  return `${id}_other`;
}

// helper function
function replaceVariables(message: string, variables: Record<string, unknown>): string {
  return message.replace(INTERPOLATION, (_, name: string) => {
    const value = variables[name];
    if (value === undefined || value === null) return '';
    if (Array.isArray(value)) return value.join(', ');
    return String(value);
  });
}
